import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { round } from 'altrac-conversions'
import { DecimalInput, isNumber } from '../Inputs/Inputs'
import styles from '../../../../css/devicePage.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const RpmMultiplier = ({ device }) => {
  const {
    physical: {
      rpmMultiplier = 1,
    } = {},
  } = device || {}

  const [rpmMultiplierState, setRpmMultiplierState] = useState(round(1 / rpmMultiplier, 2))

  const appDispatch = useCallback(() => {
    let rpmMultiplierValue = (1 / device.physical.rpmMultiplier)

    if (isNumber(rpmMultiplierState)) {
      rpmMultiplierValue = Number(rpmMultiplierState)
    }

    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        rpmMultiplier: (1 / rpmMultiplierValue),
      },
    })
  }, [rpmMultiplierState, device.physical.rpmMultiplier])

  useEffect(() => {
    appDispatch()
  }, [rpmMultiplierState, appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    setRpmMultiplierState(value)
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          RPM Multiplier
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <DecimalInput
            value={rpmMultiplierState}
            childChange={childChange}
            field='rpmMultiplier'
          />
        </div>
      </section>
    </div>
  )
}

RpmMultiplier.propTypes = {
  device: PropTypes.object.isRequired,
}

export default RpmMultiplier
